import { createMissingSchemaLink } from "./createMissingSchemaLink";
function getSchemaId(schema, observabilityFns) {
    const firstQuery = Object.values(schema.topLevelFields.queries)[0];
    if (firstQuery) {
        return firstQuery.schemaId;
    }
    const firstMutation = Object.values(schema.topLevelFields.mutations)[0];
    if (firstMutation) {
        return firstMutation.schemaId;
    }
    observabilityFns === null || observabilityFns === void 0 ? void 0 : observabilityFns.errors.error('No schema ID found in schema configuration', {
        project: 'sail_core',
        extras: {
            firstQueryName: Object.keys(schema.topLevelFields.queries)[0],
            firstMutationName: Object.keys(schema.topLevelFields.mutations)[0]
        }
    });
    return undefined;
}
export default function createSchemaLinksConfiguration(schemas, observabilityFns) {
    const schemaIdToApolloLink = {
        UNKNOWN_SCHEMA: createMissingSchemaLink()
    };
    const topLevelFieldNameToMetadata = {
        queries: {},
        mutations: {}
    };
    schemas.forEach((schema, index)=>{
        const schemaId = getSchemaId(schema, observabilityFns) || `v${index}`;
        schemaIdToApolloLink[schemaId] = schema.apolloLink;
        Object.assign(topLevelFieldNameToMetadata.queries, schema.topLevelFields.queries);
        Object.assign(topLevelFieldNameToMetadata.mutations, schema.topLevelFields.mutations);
    });
    return {
        schemaIdToApolloLink,
        topLevelFieldNameToMetadata
    };
}

//# sourceMappingURL=createSchemaLinksConfiguration.js.map